import { Request } from 'effect';
export class GetTokenError {
    originalError;
    _tag = 'GetTokenError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export const GetToken = Request.tagged('GetToken');
